import { render, staticRenderFns } from "./xuekeuniversity.vue?vue&type=template&id=7efda02f&scoped=true"
import script from "./xuekeuniversity.vue?vue&type=script&lang=js"
export * from "./xuekeuniversity.vue?vue&type=script&lang=js"
import style0 from "./xuekeuniversity.vue?vue&type=style&index=0&id=7efda02f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efda02f",
  null
  
)

export default component.exports